import React from 'react';
import { Button, Divider } from 'antd';
import cx from 'classnames';

import { BaseModal, BaseModalFooter } from 'components/wrappers/BaseModal';
import styles from './AdditionalInfoViewModal.module.less';

type Props = {
  onClose: () => void;
  requestMessage?: string;
  responseMessage?: string;
};

export default function AdditionalInfoViewModal(props: Props) {
  const { onClose, responseMessage, requestMessage } = props;

  return (
    <BaseModal
      title="Request details"
      open={true}
      maxWidth={468}
      onCancel={onClose}
    >
      <div className={cx('modal-scroll-wrapper', styles.message)}>
        {requestMessage && (
          <>
            <div className={styles.title}>Admin request:</div>
            <div>{requestMessage}</div>
          </>
        )}

        <Divider className="modal-divider" />


        {responseMessage && (
          <>
            <div className={styles.title}>User response:</div>
            <div>{responseMessage}</div>
          </>
        )}
      </div>

      <BaseModalFooter>
        <Button onClick={onClose}>Cancel</Button>
      </BaseModalFooter>
    </BaseModal>
  );
}
